import { Box, Stack, Typography } from '@common-components';
import { ArrowDownward, ArrowUpward } from '@icons';
import { queueColumnsConfig, QueueSortType, QueueSortTypeMap } from './config';

const iconSize = 12;

interface QueueTableHeaderProps {
  sortType: QueueSortType;
  setSortType: (value: QueueSortType) => void;
}

export default function QueueTableHeader({ sortType, setSortType }: QueueTableHeaderProps) {
  const handleSort = (columnKey: string) => {
    const { asc, desc } = QueueSortTypeMap[columnKey];

    if (sortType === desc) {
      setSortType(asc);
    } else {
      setSortType(desc);
    }
  };

  const getSortIcon = (columnKey: string, isSorted: boolean) => {
    const { asc } = QueueSortTypeMap[columnKey];

    if (isSorted) {
      return sortType === asc ? (
        <ArrowUpward sx={{ fontSize: iconSize }} />
      ) : (
        <ArrowDownward sx={{ fontSize: iconSize }} />
      );
    }
    return <ArrowDownward sx={{ fontSize: iconSize }} />;
  };

  return (
    <Stack
      bgcolor="common.white"
      position="sticky"
      top={0}
      zIndex={(theme) => theme.zIndex.appBar}
      direction="row"
      flex={0}
      gap={1}
      px={2}
      borderBottom={1}
      borderColor="divider"
    >
      {Object.values(queueColumnsConfig).map((column) => {
        const sortConfig = QueueSortTypeMap[column.key];
        const isSorted = sortType === sortConfig?.asc || sortType === sortConfig?.desc;

        return (
          <Stack
            py={2}
            key={column.key}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width={1}
            flex={column.flex}
            onClick={() => sortConfig && handleSort(column.key)}
            sx={{
              cursor: sortConfig ? 'pointer' : 'default',
              '&:hover .sort-icon': {
                visibility: sortConfig ? 'visible' : 'hidden',
              },
            }}
          >
            <Typography variant="caption" color="text.secondary" fontWeight={isSorted ? 'bold' : 'normal'}>
              {column.title}
            </Typography>
            {sortConfig && (
              <Box
                className="sort-icon"
                sx={{
                  visibility: isSorted ? 'visible' : 'hidden',
                  mx: 2,
                }}
              >
                {getSortIcon(column.key, isSorted)}
              </Box>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
}
